import jquery from 'jquery';
import whatInput from 'what-input';
import foundation from 'foundation-sites';
import slickCarousel from 'slick-carousel';
// import owlStyle from 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel';


$(document).foundation();
// slideCompare
jQuery(document).ready(function($){
  initializeSlick();
  initializeSlideCompare($);
  // console.log('aletr boo');
});

function initializeSlideCompare($) {
  var dragging = false,
      scrolling = false,
      resizing = false;
  //cache jQuery objects
  var imageComparisonContainers = $('.cd-image-container');
  //check if the .cd-image-container is in the viewport
  //if yes, animate it
  checkPosition(imageComparisonContainers);
  $(window).on('scroll', function(){
      if( !scrolling) {
          scrolling =  true;
          ( !window.requestAnimationFrame )
              ? setTimeout(function(){checkPosition(imageComparisonContainers);}, 100)
              : requestAnimationFrame(function(){checkPosition(imageComparisonContainers);});
      }
  });

  //make the .cd-handle element draggable and modify .cd-resize-img width according to its position
  imageComparisonContainers.each(function(){
      var actual = $(this);
      drags(actual.find('.cd-handle'), actual.find('.cd-resize-img'), actual, actual.find('.cd-image-label[data-type="original"]'), actual.find('.cd-image-label[data-type="modified"]'));
  });

  //upadate images label visibility
  $(window).on('resize', function(){
      if( !resizing) {
          resizing =  true;
          ( !window.requestAnimationFrame )
              ? setTimeout(function(){checkLabel(imageComparisonContainers);}, 100)
              : requestAnimationFrame(function(){checkLabel(imageComparisonContainers);});
      }
  });

  function checkPosition(container) {
      container.each(function(){
          var actualContainer = $(this);
          if( $(window).scrollTop() + $(window).height()*0.5 > actualContainer.offset().top) {
              actualContainer.addClass('is-visible');
          }
      });

      scrolling = false;
  }

  function checkLabel(container) {
      container.each(function(){
          var actual = $(this);
          updateLabel(actual.find('.cd-image-label[data-type="modified"]'), actual.find('.cd-resize-img'), 'left');
          updateLabel(actual.find('.cd-image-label[data-type="original"]'), actual.find('.cd-resize-img'), 'right');
      });

      resizing = false;
  }

  //draggable funtionality - credits to http://css-tricks.com/snippets/jquery/draggable-without-jquery-ui/
  function drags(dragElement, resizeElement, container, labelContainer, labelResizeElement) {
      dragElement.on("mousedown vmousedown", function(e) {
          dragElement.addClass('draggable');
          resizeElement.addClass('resizable');

          var dragWidth = dragElement.outerWidth(),
              xPosition = dragElement.offset().left + dragWidth - e.pageX,
              containerOffset = container.offset().left,
              containerWidth = container.outerWidth(),
              minLeft = containerOffset + 10,
              maxLeft = containerOffset + containerWidth - dragWidth - 10;

          dragElement.parents().on("mousemove vmousemove", function(e) {
              if( !dragging) {
                  dragging =  true;
                  ( !window.requestAnimationFrame )
                      ? setTimeout(function(){animateDraggedHandle(e, xPosition, dragWidth, minLeft, maxLeft, containerOffset, containerWidth, resizeElement, labelContainer, labelResizeElement);}, 100)
                      : requestAnimationFrame(function(){animateDraggedHandle(e, xPosition, dragWidth, minLeft, maxLeft, containerOffset, containerWidth, resizeElement, labelContainer, labelResizeElement);});
              }
          }).on("mouseup vmouseup", function(e){
              dragElement.removeClass('draggable');
              resizeElement.removeClass('resizable');
          });
          e.preventDefault();
      }).on("mouseup vmouseup", function(e) {
          dragElement.removeClass('draggable');
          resizeElement.removeClass('resizable');
      });
  }

  function animateDraggedHandle(e, xPosition, dragWidth, minLeft, maxLeft, containerOffset, containerWidth, resizeElement, labelContainer, labelResizeElement) {
      var leftValue = e.pageX + xPosition - dragWidth;
      //constrain the draggable element to move inside his container
      if(leftValue < minLeft ) {
          leftValue = minLeft;
      } else if ( leftValue > maxLeft) {
          leftValue = maxLeft;
      }

      var widthValue = (leftValue + dragWidth/2 - containerOffset)*100/containerWidth+'%';

      $('.draggable').css('left', widthValue).on("mouseup vmouseup", function() {
          $(this).removeClass('draggable');
          resizeElement.removeClass('resizable');
      });

      $('.resizable').css('width', widthValue);

      updateLabel(labelResizeElement, resizeElement, 'left');
      updateLabel(labelContainer, resizeElement, 'right');
      dragging =  false;
  }

  function updateLabel(label, resizeElement, position) {
      if(position == 'left') {
          ( label.offset().left + label.outerWidth() < resizeElement.offset().left + resizeElement.outerWidth() ) ? label.removeClass('is-hidden') : label.addClass('is-hidden') ;
      } else {
          ( label.offset().left > resizeElement.offset().left + resizeElement.outerWidth() ) ? label.removeClass('is-hidden') : label.addClass('is-hidden') ;
      }
  }

}

function initializeSlick() {
  jQuery('.slide-imgs').slick(
    {
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      draggable: false,
      swipe: false,
      adaptiveHeight: true
    });
$('.slide-imgs').resize();

  // OWL slideshow
  jQuery(".owl-carousel").owlCarousel({
    items:1,
    dots: true,
    autoHeight: true
  });
  $('.owl-carousel').resize();

}

$('#modalSinglePage').on('open.zf.reveal', function() {

  var pageID = $(this).attr('data-id');
  var modalObj = $(this);

  // Sera affiché lors du chargement des infos
  var htmlVide = '';
      htmlVide += '<div class="row">';
        htmlVide += '<div class="columns medium-12 large-12 blk-textes">';
          htmlVide += '<div class="showbox"><div class="loader" id="chargement"><svg class="circular" viewBox="25 25 50 50"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div></div>';
        htmlVide += '</div>';
      htmlVide += '</div>';
      // htmlVide += '<button class="close-button" data-close aria-label="Close reveal" type="button"><span aria-hidden="true"><i class="fa fa-arrow-left"></i>Retour au circuit</span></button><button class="close-button" data-close aria-label="Close reveal" type="button">';
      //   htmlVide += '<span aria-hidden="true">&times;</span>';
      // htmlVide += '</button>';
  $(this).html(htmlVide);

  $.ajax('/wp-json/wp/v2/cpt_circuits?include='+pageID)
    .done(function(resp){
      resp = resp[0];
      try {
        // On essaie de faire afficher ceci.. S'il y a erreur, le catch prend la relève
        /**
         * ATTENTION!
         *
         * Cette structure est la même que le fichier "single-cpt_circuits.php".
         * Si tu fais des modifications sur ce fichier, les faire également dans le fichier en question.
         */
        var html = '';
        html += '<div class="row">';
          html += '<div class="columns medium-12 large-6 blk-imgs">';
          // début slide owl
          html += '<div class="owl-carousel">';
            if (resp.acf._photo_epoque_1 && resp.acf._photo_recente_1) {
              html += '<div class="slide">';
                html += '<figure class="cd-image-container">';
                  html += '<img src="'+resp.acf._photo_epoque_1.url+'" alt="'+resp.acf._annee_epoque_1+'">';
                  html += '<span class="cd-image-label" data-type="original">'+resp.acf._annee_epoque_1+'</span>';

                  html += '<div class="cd-resize-img"> <!-- the resizable image on top -->';
                    html += '<img src="'+resp.acf._photo_recente_1.url+'" alt="'+resp.acf._annee_recente_1+'">';
                    html += '<span class="cd-image-label" data-type="modified">'+resp.acf._annee_recente_1+'</span>';
                  html += '</div>';

                  html += '<span class="cd-handle"></span>';
                html += '</figure> <!-- cd-image-container -->';

                html += '<small>Déplacez l’icône sur l’image pour un aperçu </small>';
              html += '</div>';
            }
            if (resp.acf._photo_epoque_2 && resp.acf._photo_recente_2) {
              html += '<div class="slide">';
                html += '<figure class="cd-image-container">';
                  html += '<img src="'+resp.acf._photo_epoque_2.url+'" alt="'+resp.acf._annee_epoque_2+'">';
                  html += '<span class="cd-image-label" data-type="original">'+resp.acf._annee_epoque_2+'</span>';

                  html += '<div class="cd-resize-img"> <!-- the resizable image on top -->';
                    html += '<img src="'+resp.acf._photo_recente_2.url+'" alt="'+resp.acf._annee_recente_2+'">';
                    html += '<span class="cd-image-label" data-type="modified">'+resp.acf._annee_recente_2+'</span>';
                  html += '</div>';

                  html += '<span class="cd-handle"></span>';
                html += '</figure> <!-- cd-image-container -->';

                html += '<small>Déplacez l’icône sur l’image pour un aperçu </small>';
              html += '</div>';
            }
            if (resp.acf._photo_epoque_3 && resp.acf._photo_recente_3) {
              html += '<div class="slide">';
                html += '<figure class="cd-image-container">';
                  html += '<img src="'+resp.acf._photo_epoque_3.url+'" alt="'+resp.acf._annee_epoque_3+'">';
                  html += '<span class="cd-image-label" data-type="original">'+resp.acf._annee_epoque_3+'</span>';

                  html += '<div class="cd-resize-img"> <!-- the resizable image on top -->';
                    html += '<img src="'+resp.acf._photo_recente_3.url+'" alt="'+resp.acf._annee_recente_3+'">';
                    html += '<span class="cd-image-label" data-type="modified">'+resp.acf._annee_recente_3+'</span>';
                  html += '</div>';

                  html += '<span class="cd-handle"></span>';
                html += '</figure> <!-- cd-image-container -->';

                html += '<small>Déplacez l’icône sur l’image pour un aperçu </small>';
              html += '</div>';
            }
            if (resp.acf._photo_epoque_4 && resp.acf._photo_recente_4) {
              html += '<div class="slide">';
                html += '<figure class="cd-image-container">';
                  html += '<img src="'+resp.acf._photo_epoque_4.url+'" alt="'+resp.acf._annee_epoque_4+'">';
                  html += '<span class="cd-image-label" data-type="original">'+resp.acf._annee_epoque_4+'</span>';

                  html += '<div class="cd-resize-img"> <!-- the resizable image on top -->';
                    html += '<img src="'+resp.acf._photo_recente_4.url+'" alt="'+resp.acf._annee_recente_4+'">';
                    html += '<span class="cd-image-label" data-type="modified">'+resp.acf._annee_recente_4+'</span>';
                  html += '</div>';

                  html += '<span class="cd-handle"></span>';
                html += '</figure> <!-- cd-image-container -->';

                html += '<small>Déplacez l’icône sur l’image pour un aperçu </small>';
              html += '</div>';
            }
            if (resp.acf.img_slide_1) {
              html += '<div class="slide">';
                html += '<img src="'+resp.acf.img_slide_1.url+'" alt="'+resp.acf.img_slide_1+'">';
                html += resp.acf.desc_img_1;
              html += '</div>'; }
            if (resp.acf.img_slide_2) {
                html += '<div class="slide">';
                  html += '<img src="'+resp.acf.img_slide_2.url+'" alt="'+resp.acf.img_slide_2+'">';
                  html += resp.acf.desc_img_2;
                html += '</div>';
              }
            if (resp.acf.img_slide_3) {
                html += '<div class="slide">';
                  html += '<img src="'+resp.acf.img_slide_3.url+'" alt="'+resp.acf.img_slide_3+'">';
                  html += resp.acf.desc_img_3;
                html += '</div>';
              }
            if (resp.acf.img_slide_4) {
                html += '<div class="slide">';
                  html += '<img src="'+resp.acf.img_slide_4.url+'" alt="'+resp.acf.img_slide_4+'">';
                  html += resp.acf.desc_img_4;
                html += '</div>';
              }
            if (resp.acf.img_slide_5) {
                html += '<div class="slide">';
                  html += '<img src="'+resp.acf.img_slide_5.url+'" alt="'+resp.acf.img_slide_5+'">';
                  html += resp.acf.desc_img_5;
                html += '</div>';
              }
            if (resp.acf.img_slide_6) {
                html += '<div class="slide">';
                  html += '<img src="'+resp.acf.img_slide_6.url+'" alt="'+resp.acf.img_slide_6+'">';
                  html += resp.acf.desc_img_6;
                html += '</div>';
              }
          html += '</div>';
          // Fin du slide owl



























            // html += '<div class="slide-imgs">';
            //   if (resp.acf._photo_epoque_1 && resp.acf._photo_recente_1) {
            //     html += '<div class="slide">';
            //       html += '<figure class="cd-image-container">';
            //         html += '<img src="'+resp.acf._photo_epoque_1.url+'" alt="'+resp.acf._annee_epoque_1+'">';
            //         html += '<span class="cd-image-label" data-type="original">'+resp.acf._annee_epoque_1+'</span>';
            //
            //         html += '<div class="cd-resize-img"> <!-- the resizable image on top -->';
            //           html += '<img src="'+resp.acf._photo_recente_1.url+'" alt="'+resp.acf._annee_recente_1+'">';
            //           html += '<span class="cd-image-label" data-type="modified">'+resp.acf._annee_recente_1+'</span>';
            //         html += '</div>';
            //
            //         html += '<span class="cd-handle"></span>';
            //       html += '</figure> <!-- cd-image-container -->';
            //
            //       html += '<small>Déplacez l’icône sur l’image pour un aperçu </small>';
            //     html += '</div>';
            //   }
            //   if (resp.acf._photo_epoque_2 && resp.acf._photo_recente_2) {
            //     html += '<div class="slide">';
            //       html += '<figure class="cd-image-container">';
            //         html += '<img src="'+resp.acf._photo_epoque_2.url+'" alt="'+resp.acf._annee_epoque_2+'">';
            //         html += '<span class="cd-image-label" data-type="original">'+resp.acf._annee_epoque_2+'</span>';
            //
            //         html += '<div class="cd-resize-img"> <!-- the resizable image on top -->';
            //           html += '<img src="'+resp.acf._photo_recente_2.url+'" alt="'+resp.acf._annee_recente_2+'">';
            //           html += '<span class="cd-image-label" data-type="modified">'+resp.acf._annee_recente_2+'</span>';
            //         html += '</div>';
            //
            //         html += '<span class="cd-handle"></span>';
            //       html += '</figure> <!-- cd-image-container -->';
            //
            //       html += '<small>Déplacez l’icône sur l’image pour un aperçu </small>';
            //     html += '</div>';
            //   }
            //   if (resp.acf._photo_epoque_3 && resp.acf._photo_recente_3) {
            //     html += '<div class="slide">';
            //       html += '<figure class="cd-image-container">';
            //         html += '<img src="'+resp.acf._photo_epoque_3.url+'" alt="'+resp.acf._annee_epoque_3+'">';
            //         html += '<span class="cd-image-label" data-type="original">'+resp.acf._annee_epoque_3+'</span>';
            //
            //         html += '<div class="cd-resize-img"> <!-- the resizable image on top -->';
            //           html += '<img src="'+resp.acf._photo_recente_3.url+'" alt="'+resp.acf._annee_recente_3+'">';
            //           html += '<span class="cd-image-label" data-type="modified">'+resp.acf._annee_recente_3+'</span>';
            //         html += '</div>';
            //
            //         html += '<span class="cd-handle"></span>';
            //       html += '</figure> <!-- cd-image-container -->';
            //
            //       html += '<small>Déplacez l’icône sur l’image pour un aperçu </small>';
            //     html += '</div>';
            //   }
            //   if (resp.acf._photo_epoque_4 && resp.acf._photo_recente_4) {
            //     html += '<div class="slide">';
            //       html += '<figure class="cd-image-container">';
            //         html += '<img src="'+resp.acf._photo_epoque_4.url+'" alt="'+resp.acf._annee_epoque_4+'">';
            //         html += '<span class="cd-image-label" data-type="original">'+resp.acf._annee_epoque_4+'</span>';
            //
            //         html += '<div class="cd-resize-img"> <!-- the resizable image on top -->';
            //           html += '<img src="'+resp.acf._photo_recente_4.url+'" alt="'+resp.acf._annee_recente_4+'">';
            //           html += '<span class="cd-image-label" data-type="modified">'+resp.acf._annee_recente_4+'</span>';
            //         html += '</div>';
            //
            //         html += '<span class="cd-handle"></span>';
            //       html += '</figure> <!-- cd-image-container -->';
            //
            //       html += '<small>Déplacez l’icône sur l’image pour un aperçu </small>';
            //     html += '</div>';
            //   }
            //   if (resp.acf.img_slide_1) {
            //     html += '<div class="slide">';
            //       html += '<img src="'+resp.acf.img_slide_1.url+'" alt="'+resp.acf.img_slide_1+'">';
            //       html += resp.acf.desc_img_1;
            //     html += '</div>'; }
            //   if (resp.acf.img_slide_2) {
            //       html += '<div class="slide">';
            //         html += '<img src="'+resp.acf.img_slide_2.url+'" alt="'+resp.acf.img_slide_2+'">';
            //         html += resp.acf.desc_img_2;
            //       html += '</div>';
            //     }
            //   if (resp.acf.img_slide_3) {
            //       html += '<div class="slide">';
            //         html += '<img src="'+resp.acf.img_slide_3.url+'" alt="'+resp.acf.img_slide_3+'">';
            //         html += resp.acf.desc_img_3;
            //       html += '</div>';
            //     }
            //   if (resp.acf.img_slide_4) {
            //       html += '<div class="slide">';
            //         html += '<img src="'+resp.acf.img_slide_4.url+'" alt="'+resp.acf.img_slide_4+'">';
            //         html += resp.acf.desc_img_4;
            //       html += '</div>';
            //     }
            // html += '</div>';
          html += '</div>';
          html += '<div class="columns medium-12 large-6 blk-textes">';
            html += '<div class="single-title">';
              html += '<h2><span>'+(resp.acf._circuit).toUpperCase()+'</span>'+(resp.title.rendered).toUpperCase()+'<small style="display:block;font-size:14px;margin-bottom:30px;margin-top: 10px;">'+(resp.acf.sous_titre)+'</small></h2>';
            html += '</div>';
            html += resp.content.rendered;
          html += '</div>';
        html += '</div>';
        html += '<button class="close-button btn-retour" data-close aria-label="Retour au circuit" type="button">';
          html += '<span aria-hidden="true"><i class="ic ic-fleche-gauche"></i> Retour au circuit</span>';
        html += '</button>';
        html += '<button class="close-button" data-close aria-label="Retour au circuit" type="button">';
          html += '<span aria-hidden="true">&times;</span>';
        html += '</button>';
        modalObj.html(html);


          // Réinitialisation des scripts
          initializeSlideCompare($);
          initializeSlick();

          // console.log('alert');


          // document.getElementsByClassName("is-reveal-open", function(){
          //   console.log('test');
          // });

          // document.querySelector('[class="slick-list"]').style.height = "300px";
          // document.getElementById("header").style.height = "400px";

          // var element = document.querySelector('[data-open="modalSinglePage"]');

          // var btnTest = document.getElementsByClassName("is-reveal-open");
          // document.addEventListener("DOMContentLoaded", function(event){
          //   console.log('test');
          // });

          if( document.readyState === 'complete' ) {
              // console.log(Math.random());
              // document.querySelector('[class="slick-list"]').setAttribute("style", "height:100px");
              // jQuery('.slide-imgs')[0].slick.refresh();

              myInitCode();
          } else {
              document.addEventListener('DOMContentLoaded', function () {
                  console.log( 'document was not ready, place code here' );
                  myInitCode();
              });
          }

          function myInitCode() {}

      }
      catch(err) {
        // Affiché en cas d'erreur
        var htmlErreur = '';
            htmlErreur += '<div class="row">';
              htmlErreur += '<div class="columns medium-12 large-12 blk-textes">';
                htmlErreur += '<p>Désolé, les détails de ce panneau ne sont pas disponibles pour le moment.</p>';
              htmlErreur += '</div>';
            htmlErreur += '</div>';
            // htmlErreur += '<button class="close-button" data-close aria-label="Retour au circuit" type="button">';
            //   htmlErreur += '<span aria-hidden="true"><i class="ic ic-fleche-gauche"></i> Retour au circuit</span>';
            // htmlErreur += '</button>';
            htmlErreur += '<button class="close-button" data-close aria-label="Retour au circuit" type="button">';
              htmlErreur += '<span aria-hidden="true">&times;</span>';
            htmlErreur += '</button>';
        modalObj.html(htmlErreur);
      }



  });

});



//////////////////
// WEBPACK FOOTER
// ./src/js/main.js
// module id = 19
// module chunks = 0